export default "__VITE_ASSET__Doru77pE__"